import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MetricCard = ({ title, value, icon: Icon, trend, trendValue, suffix = '' }) => {
  const isPositive = trend === 'up';

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 duration-200">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="p-3 bg-blue-50 rounded-lg">
          <Icon size={24} className="text-blue-600" />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 text-sm font-medium ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
            {isPositive ? <TrendingUp size={16} /> : <TrendingDown size={16} />}
            <span>{trendValue}</span>
          </div>
        )}
      </div>

      {/* Content */}
      <div>
        <p className="text-gray-600 text-sm mb-1">{title}</p>
        <p className="text-3xl font-bold text-gray-900">
          {value}
          {suffix && <span className="text-lg text-gray-500 ml-1">{suffix}</span>}
        </p>
      </div>
    </div>
  );
};

export default MetricCard;
